export const parseStringToPlural = (word: string, total: number): string => {
  if (total > 1) {
    return `${word}s`;
  }
  return word;
};
